import get from "lodash/get";
import {getMeta} from "../../../../../src/helpers";
import {message} from "@grininc/grin-ui";

const UPLOAD_ERROR_MESSAGE = 'Upload failed, please try again or contact support';


export default {
    computed: {
        uploadHeaders() {
            return {'X-CSRF-TOKEN': getMeta('csrf-token')};
        }
    },
    methods: {
        handleUploadChange(uploadInfo, handleSuccess = null, handleError = null) {
            //Skip this one. The data is missing the response property.
            if (uploadInfo.event) {
                return;
            }
            const status = get(uploadInfo, 'file.status');
            if (status === 'done') {
                if (handleSuccess) {
                    return handleSuccess(uploadInfo);
                }
            }
            if (status === 'error') {
                if (handleError) {
                    return handleError(uploadInfo);
                }
                return this.handleUploadError(uploadInfo)
            }
        },

        handleUploadError(uploadInfo) {
            const code = get(uploadInfo, 'file.error.status');

            if (code === 422) {
                return message.error(get(uploadInfo, 'file.error.message', UPLOAD_ERROR_MESSAGE));
            }

            return message.error(UPLOAD_ERROR_MESSAGE);
        }
    }
}
